import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HttpError} from '../models/http-error.model';
import * as camelcaseKeys from 'camelcase-keys';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandlingInterceptor implements HttpInterceptor {
  constructor(@Inject(PLATFORM_ID) private platformId: string) {
  }

  handleError(error: HttpErrorResponse): Observable<HttpEvent<any>> {
    const httpError = {} as HttpError;
    httpError.status = error.status;
    if (httpError.status === 422) {
      httpError.validation = camelcaseKeys(error.error.errors);
    } else {
      httpError.message = error.error.message ?? 'خطایی در سامانه رخ داده است.';
    }
    httpError.originalError = error.error;
    return throwError(httpError);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError(this.handleError.bind(this)), map((data) => {
      return data;
    }));
  }
}
